import { render, staticRenderFns } from "./chaishu.vue?vue&type=template&id=2788e406&scoped=true"
import script from "./chaishu.vue?vue&type=script&lang=js"
export * from "./chaishu.vue?vue&type=script&lang=js"
import style0 from "./chaishu.vue?vue&type=style&index=0&id=2788e406&prod&lang=css"
import style1 from "./chaishu.vue?vue&type=style&index=1&id=2788e406&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2788e406",
  null
  
)

export default component.exports